// Breadcrumbs for store: Store > Category > Family > Product (or Store > Orden > Solicitar cotización).
// Each segment has label and optional path; last segment is current page (no path).

import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface StoreBreadcrumbSegment {
  label: string;
  path?: string;
}

export function StoreBreadcrumbs({ segments }: { segments: StoreBreadcrumbSegment[] }) {
  if (!segments.length) return null;
  return (
    <nav className="flex items-center gap-2 text-sm text-zinc-600" aria-label="Breadcrumb">
      {segments.map((seg, i) => {
        const isLast = i === segments.length - 1;
        return (
          <span key={i} className="flex items-center gap-2">
            {i > 0 && <ChevronRight className="h-4 w-4 shrink-0 text-zinc-400" aria-hidden />}
            {seg.path && !isLast ? (
              <Link to={seg.path} className="hover:text-zinc-900 transition-colors">
                {seg.label}
              </Link>
            ) : (
              <span className={isLast ? 'font-medium text-zinc-900' : ''}>{seg.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
